/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackCreateResponseFeedback } from "../../funcs/llmFeedbackCreateResponseFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateResponseFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackCreateResponseFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-create-response-feedback",
  description: `Submit feedback for response

Submit user feedback for a specific agent response to track satisfaction and model performance. Each response can only receive feedback once.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackCreateResponseFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
